module.exports = __webpack_public_path__ + "media/images/powerpoint/media/background-gradient-dddc89e73e2982d273e36151d413826c.png";